export default __webpack_public_path__ + "static/grad-pricing-old-right-5373f419ab4d49aa4fc9318286911e93.png";